import React from 'react'
import { makeStyles, createStyles, Typography } from '@material-ui/core'
import CMSText from './CMSText'

const useStyles = makeStyles(() =>
  createStyles({
    downloadlink: {
      textDecoration: 'underline',
      texttransform: 'none',
      '&:hover, &:focus': {
        textDecoration: 'none',
      },
    },
  })
)

type TProps = {
  downloadLink: string
  data: any
  defaultText: any
}

const DownloadLink = ({ downloadLink, data, defaultText }: TProps) => {
  const classes = useStyles()
  return (
    <Typography variant={'h5'} component={'span'}>
      <a href={downloadLink} target={'blank'} className={classes.downloadlink}>
        <CMSText data={data} defaultText={defaultText} />
      </a>
    </Typography>
  )
}

export default DownloadLink
